import React, { useEffect, useState } from "react";
import useHttp from './../../../hook/use-http';
import Chart from 'react-apexcharts'
import stats from 'wink-statistics';
import NoData from './NoData';
import ChartLoader from './ChartLoader';
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates';
import { BsZoomIn } from "react-icons/bs";
import './SingleRangeBox.css';
import WaterMark from "../DashboardMain/WaterMark";
import * as d3 from "d3";

function SingleRangeBox({ apiend, gloablfilter, yaxis_title, idStr, title }) {
  const [chartdata, setChartData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  let modal_title = title;
  function median(numbers) {
    const sorted = Array.from(numbers).sort((a, b) => a - b);
    const middle = Math.floor(sorted.length / 2);

    if (sorted.length % 2 === 0) {
      if ((((sorted[middle - 1] + sorted[middle]) / 2).toFixed(2)) !== "NaN")
        return ((sorted[middle - 1] + sorted[middle]) / 2).toFixed(2);
      else
        return 0
    }
    if ((sorted[middle].toFixed(2)) !== "NaN")
      return sorted[middle].toFixed(2)
    else
      return 0
  }
  const getSummaryStats = (data) => {
    const sortedData = data.sort(function (a, b) { return a - b });

    const q1 = d3.quantile(sortedData, .25)
    const median = d3.quantile(sortedData, .50)
    const q3 = d3.quantile(sortedData, .75)

    if (!q3 || !q1 || !median) {
      return
    }

    const interQuantileRange = q3 - q1
    const min = q1 - 1.5 * interQuantileRange
    const max = q3 + 1.5 * interQuantileRange

    return { min, q1, median, q3, max }
  }

  const appyData = (data) => {
    const res_result = data;
    if (res_result.length != 0) {
      let temp_result = res_result;
      let res_result_final = [{
        type: 'boxPlot',
        data: []
      }]
      let y_data_set = [];
      temp_result.map(x => {
        if (x.Range.values["50.0"] != null) {
          y_data_set.push(parseFloat((x.Range.values["50.0"]).toFixed(2)));
        }
      })
      y_data_set = y_data_set.sort(function (a, b) { return a - b });
      var boxplot = stats.data.boxplot;
      let data_set = boxplot(y_data_set);
      res_result_final[0].data.push({ x: "Ace Ev", y: [data_set.min.toFixed(2), data_set.q1.toFixed(2), data_set.median.toFixed(2), data_set.q3.toFixed(2), data_set.max.toFixed(2)] })
      setChartData((prestate) => res_result_final);
      window.dispatchEvent(new Event('resize'));
    } else {
      setChartData((prestate) => []);
      window.dispatchEvent(new Event('resize'));
    }
  }

  const options = {
    tooltip: {
      followCursor: true,
      fixed: {
        enabled: true,
        position: 'topLeft',
        offsetX: -20,
        offsetY: -100,
      },
    },
    chart: {
      toolbar: {
        show: false
      },
      type: 'boxPlot',
      height: 350,
    },
    yaxis: {
      title: {
        show: true,
        text: yaxis_title,
        style: {
          color: undefined,
          fontSize: '9px',
          fontStyle: "italic",
          fontFamily: 'Helvetica, Arial, sans-serif',
          fontWeight: 100,
        }
      },
      labels: {
        formatter: function (val) {
          return val.toFixed(0);
        }
      }
    },
    grid: {
      yaxis: {
        lines: {
          show: false,
        }
      }
    },
    plotOptions: {
      boxPlot: {
        colors: {
          upper: '#FFFFFF',
          lower: '#FFFFFF'
        }
      }
    }
  };

  const options_popup = {
    tooltip: {
      followCursor: true,
      fixed: {
        enabled: true,
        position: 'topLeft',
        offsetX: -20,
        offsetY: -60,
      },
    },
    chart: {
      toolbar: {
        show: false
      },
      type: 'boxPlot',
      height: 350,
    },
    yaxis: {
      title: {
        show: true,
        text: yaxis_title,
        style: {
          color: undefined,
          fontSize: '9px',
          fontStyle: "italic",
          fontFamily: 'Helvetica, Arial, sans-serif',
          fontWeight: 100,
        }
      },
      labels: {
        formatter: function (val) {
          return val.toFixed(0);
        }
      }
    },
    grid: {
      yaxis: {
        lines: {
          show: false,
        }
      }
    },
    plotOptions: {
      boxPlot: {
        colors: {
          upper: '#FFFFFF',
          lower: '#FFFFFF'
        }
      }
    }
  };

  useEffect(() => {
    fetchData({ url: API_URL_MAIN + "charts/" + apiend, body: { filterdata: gloablfilter } }, appyData)
  }, [gloablfilter])

  return (
    <>
      <div className="modal fade" id={idStr + "modal"} data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">{modal_title}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body" style={{ height: "400px" }}>
              <WaterMark />
              {(isLoading) ? <ChartLoader /> : (chartdata.length == 0) ? <NoData /> : <Chart options={options_popup} series={chartdata} type="boxPlot" height={300} />}
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-6" style={{ paddingRight: "5px", paddingLeft: "5px" }}>
        <div className="titlebg " style={{ margin: "0px" }}><strong className="Zoom_first_page" style={{ float: "right", cursor: "pointer" }} data-bs-toggle="modal" data-bs-target={"#" + idStr + "modal"} > <BsZoomIn /> </strong>
        </div>
        <WaterMark />
        <div className="chartHGT" style={{ marginTop: "10%" }}>
          {(isLoading) ? <ChartLoader /> : (chartdata.length == 0) ? <NoData /> : <Chart options={options} series={chartdata} type="boxPlot" height={220} />}
        </div>
      </div>
    </>
  );
}

export default SingleRangeBox;